/**
 * A ReflectionProbe node in the scene graph, which its scene's probes find, capture and draw
 * (`sceneProbes.ts`). It carries its node's world transform, the properties it draws with and its place in the tree.
 */
import * as THREE from 'three';
export class ReflectionProbeObject extends THREE.Object3D {
    isReflectionProbe = true;
    /** Set by the probe's component before the scene's probes first read it. */
    probe;
    /** Set by the probe's component. Godot orders equal boxes by it, and the mount order differs. */
    treeOrder;
}
export function isReflectionProbe(object) {
    return object.isReflectionProbe === true;
}
//# sourceMappingURL=reflectionProbeObject.js.map